export const frontmatter = {
    "draft": true,
    "title": "Integración WebChat",
    "description": "Integra el WebChat de OnnIA en tu sitio web mediante widgets.",
    "sidebar_label": "WebChat",
    "sidebar_group": "guías",
    "sidebar_order": 2
}

export const toc = []